import React, { useCallback, useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Button, Input } from '@material-ui/core';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Badge from '@material-ui/core/Badge';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MailIcon from '@material-ui/icons/Mail';
import { styled, alpha } from '@mui/material/styles';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import Divider from '@mui/material/Divider';
import Logo from './logo.svg';
import Profile from './profile.svg';
import Cookies from 'js-cookie';
import Modal from '@mui/material/Modal'
import MaintainenceGuy from '../../images/undraw_maintenance_re_59vn 1.png'
import handleLogout from '../../Logout/logout';

import './style.css'

import axiosInstance from '../../axios';
import { useHistory } from "react-router-dom";

import srch from './searchicon.svg';
//import cross from './cross.png';
import arrow from './arrow.svg';

function DrawerComponent() {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [loginModal, setLoginModal] = useState(false)

    const [NotianchorEl, setNotiAnchorEl] = useState(null);
    const [profile, setprofile] = useState({
        "name": '',
        "email": '',
        "phone": '',
        'profile_pic': null
    })

    useEffect(() => {
        // if(!(localStorage.getItem('name') && localStorage.getItem('email') && localStorage.getItem('phone')))

        // window.addEventListener('storage', ()=>{
        //   console.log('hello');
        setprofile({
            "name": (localStorage.getItem('name') === '' || localStorage.getItem('name') === 'null') ? '' : localStorage.getItem('name'),
            "email": (localStorage.getItem('email') === '' || localStorage.getItem('email') === 'null') ? '' : localStorage.getItem('email'),
            "phone": (localStorage.getItem('phone') === '' || localStorage.getItem('phone') === 'null') ? '' : localStorage.getItem('phone'),
            "profile_pic": (localStorage.getItem('profile_pic') === '' || localStorage.getItem('profile_pic') === 'null') ? '' : localStorage.getItem('profile_pic')
        })
        // })
        // console.log(profile);
    }, [])


  
    const history = useHistory();

    const [notifications, setnotifications] = useState([]);
    const [notificationCount, setnotificationCount] = useState(0);
    
      useEffect(() => {
          notificationFetch();
        }, [notificationCount])
    
      const notificationFetch = () => {
          axiosInstance.get('/auth/notification/').then(res=>{
            setnotifications(res.data.data.notifications);
            setnotificationCount(res.data.data.count);
          }).catch(err=>{
            console.log(err);
          })
        }
    
        const notificationClick = (id, job_id) => {
          // console.log(notification);
          // axiosInstance.post('/notification/changeStatus', { id })
          const data = {
            // access : localStorage.getItem('access_token'),
            notification_id : id
          }
          axiosInstance.post('/auth/notiification_change/', data).then(res=>{
            console.log(res);
            setnotificationCount(notificationCount-1);
            if(job_id){
              sessionStorage.setItem('mobJobId', job_id);
              history.push('/job-detail');
            }
          }).catch(err=>{
            console.log(err);
          })
        }
    
        const markAsRead = () => {
          axiosInstance.post('/auth/mark_all_notification/').then(res=>{
            setnotificationCount(0);
            notificationFetch();
          }).catch(err=>{
            console.log(err);
          })
        }
    
    
    


    const Notiopen = Boolean(NotianchorEl);
    const NotihandleClick = (event) => {
        setNotiAnchorEl(event.currentTarget);
    };
    const NotihandleClose = () => {
        setNotiAnchorEl(null);
    };

    

    const handleSandwichClick = () => {
        const sandwichBtn = document.querySelector(".navbar-toggler-icon");
        sandwichBtn.classList.toggle("crossBtn");
        console.log("Clicked")
    }



    return (
        <>
            <Navbar className="navbar" fixed="top" collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand href="/dashboard"><img src={Logo} alt="logo" /></Navbar.Brand>

                    <Nav.Link href="#memes" onClick={() => setLoginModal(true)}>
                        <Badge badgeContent={1} color="primary" style={{ color: 'black' }}>
                            <ChatBubbleOutlineIcon />
                        </Badge>
                    </Nav.Link>

                    <Nav.Link onClick={NotihandleClick} id="noti-menu">
                        <div>
                            <Badge badgeContent={notificationCount} color="primary" aria-owns={anchorEl ? 'simple-menu' : undefined}
                                aria-haspopup="true" style={{ color: 'black' }} >
                                <NotificationsNoneIcon />
                            </Badge>
                        </div>

                    </Nav.Link>
                    <StyledMenu
                        id="noti-menu"
                        anchorEl={NotianchorEl}
                        open={Notiopen}
                        onClose={NotihandleClose}
                    >
                        <div className='notificationDD'>
                            <div className="notiDDHeader">
                                <div className="notiDDTitle">Notifications</div>
                                <div className="notiDDsubTitle" onClick={markAsRead}>Mark all as read</div>
                            </div>
                            <div className="noiCont" onClick={() => setLoginModal(true)}>
                            {
                                notifications && notifications.map(item=>{
                                    return(<>
                                        <Notification notificationClick={notificationClick} id={item.id} img='//placedog.net/40/40' name={item.title} created_at = {item.created_at} job_id = {item.job_id} desc={item.message} />
        
                                    </>)
                                })
                            }
                            </div>
                            <div className="notiC2a">View All</div>
                        </div>
                    </StyledMenu>



                    <Navbar.Toggle className="navbar-toggler" aria-controls="responsive-navbar-nav" onClick={handleSandwichClick}/>

                    <Navbar.Collapse id="responsive-navbar-nav" style={{ margin: '10px', width: '92%', maxWidth: '100%', maxHeight: '35rem', overflowY: 'scroll', overflowX: 'hidden' }}>
                        {/* <Nav>
                            <Box style={{ display: 'flex', flexDirection: 'row' }}>
                                <Grid item gap={3} xs={1} style={{ maxWidth: '2rem' }}>
                                    <div style={{ margin: '25% 0% 25% 0%', display: 'inline-block', verticalAlign: 'middle', background: '#fff', borderRadius: '50%', height: '30px', width: '30px' }}>
                                        <img src={cross} alt="Close" style={{ display: 'inline-block', margin: '25%', verticalAlign: 'middle' }} />
                                    </div>

                                </Grid>
                                <Grid item style={{ width: '100%', marginLeft: '10px' }}>
                                    <div className="searchBoxSmall" style={styles.searchBoxSmall}>
                                        <Grid container direction='row' spacing={1}>
                                            <Grid item xs={'auto'}>
                                                <img src={srch} alt="Search by Title" />
                                            </Grid>
                                            <Grid item xs={'auto'}>
                                                <input type="text" placeholder="Search by Job Title" style={styles.srchField} />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Box>

                        </Nav> */}


                        <Nav >
                            <div className='profileDiv' style={{background:'white'}} >
                                <Box style={{ display: 'flex', flexDirection: 'row', width:'100%' }}>
                                    <img height='49' width='49' src={
                                        (localStorage.getItem('profile_pic') === '' || localStorage.getItem('profile_pic') === 'null') ?
                                            `https://ui-avatars.com/api/?name=${profile.name}?rounded=true` : localStorage.getItem('profile_pic')
                                    } style={{ borderRadius: '50%' }} />
                                    <Box style={{width:'100%'}}>
                                        <Typography style={{ fontWeight: '600', fontSize: '18px', marginLeft: '10px', maxWidth: '80%' }}>{
                                            !(localStorage.getItem('name') === '' || localStorage.getItem('name') === 'null') ? localStorage.getItem('name') : null
                                        }</Typography>
                                        {<Typography style={{ fontSize: '14px', color: '#878E99', wordWrap: 'break-word', maxWidth: '80%', marginLeft: '10px' }}>{
                                            (localStorage.getItem('email') === '' || localStorage.getItem('email' === 'null')) ?
                                                null : localStorage.getItem('email')
                                        }</Typography>}
                                        {/* <Typography style={{ fontSize: '14px', color: '#878E99', marginLeft: '10px' }}>{
                                            (localStorage.getItem('phone') === '' || localStorage.getItem('phone' === 'null')) ?
                                                null : localStorage.getItem('phone')
                                        }</Typography> */}

                                    </Box>
                                </Box>
                            </div>
                            
                            <Nav className="me-auto" style={{ width: '100%', marginTop: '10px' }}>

                                <Nav.Link href="/search-candidate" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Candidate Search <img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/job-posting" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Job Posts<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="#jobsalert" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Favourites<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="#plans" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Frame Change Content<img src={arrow} alt="Arrow" /></Nav.Link>
                                {/* <Nav.Link href="#plans" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Subscription Plans<img src={arrow} alt="Arrow" /></Nav.Link> */}
                            </Nav>

                            <Divider />

                            
                            <Nav className="me-auto" style={{ width: '100%' }}>
                                <Nav.Link href="/employer/settings/distrProfile" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>District Profile<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/contactPreferences" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Contact Preferences<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/teamPage" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Team Page<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/userRoles" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>User Roles<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/commPreferences" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Communication Preferences<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/account" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Account<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Nav.Link href="/employer/settings/helpCentre" style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Help Center<img src={arrow} alt="Arrow" /></Nav.Link>
                                <Divider />
                                <Nav.Link onClick={handleLogout} style={{ fontWeight: '500', color: 'black', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>Logout<img src={arrow} alt="Arrow" /></Nav.Link >
                            </Nav>


                            
                        </Nav>


                    </Navbar.Collapse>

                   
                </Container>
                <Modal
                    open={loginModal}
                    onClose={() => { setLoginModal(false) }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <div className='modalCont' style={{ width: 'fit-content' }}>
                        <img src={MaintainenceGuy} alt="" />
                        <div className='loginModalHead'>This action is not available yet...</div>
                        <div className='loginModalSubHead'>We are woking on it, please come back later.</div>
                        <button className='loginModalBtn' onClick={() => setLoginModal(false)}>Okay</button>
                    </div>
                </Modal>
            </Navbar>
        </>
    );
}
export default DrawerComponent;



const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(5),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}))

const Notification = (props) => {
    return (
        <div className="notification">
            <img src={props.img} alt="" className="notiImg" />
            <div className="notiBody">
                <div className="notiBodyHead">
                    <div className="notiName">{props.name}</div>
                    <div className="notiTime">{props.time} min ago</div>
                </div>
                <div className="notiDesc">{props.desc}</div>
            </div>
        </div>
    )
}

const styles = {

    searchBoxSmall: {
        fontSize: '14px',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        background: '#fff',
        border: '1px solid #BEBEBE',
        borderRadius: '25px',
        paddingLeft: '1em',
        paddingRight: '1em',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    srchField: {
        border: "none",
        borderColor: "transparent",
        outline: "none",
        width: "100%",
    },
}
